import {
  Avatar,
  Button as MuiButton,
  CircularProgress,
  Grid,
  IconButton,
} from "@mui/material";
import { Box } from "@mui/system";
import React, { useState } from "react";
// import { ThemeProvider, createTheme } from '@mui/material/styles';
import WarningIcon from "@mui/icons-material/Warning";
import { Button, useGetOne, useCreate, useNotify, useGetIdentity, usePermissions, useDataProvider } from "react-admin";
import { NumericFormat } from "react-number-format";
import EditIcon from "@mui/icons-material/Edit";
import InfoIcon from "@mui/icons-material/Info";
import { JSONTree } from "react-json-tree";
import moment from "moment";
import AddressRentEdit from "./AddressRentEdit";
import BasicPopover from "./GetsubscriberinboxListDetails";
import WarningPrelimNotice from "./WarningPrelimNotice";
import Typography from "@mui/material/Typography";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../Store/store";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";
import { useNavigate, useLocation, useParams } from "react-router";
import { ArrowBack } from "@mui/icons-material";
import DateComponent from "./DateComponent";
import { config } from "process";
import { typesofUsers } from "../../config";
import { checkModuleAccess, isSuperAdmin } from "../../Functions/permissions";
import AddressRentEditForProperty from "./AddressRentEditForProperty";
import VerificationInfoMessage from "./VerificationInfoMessage";
import { getAtsStatusDisplayLabel } from "../../utils/atsApplicationStatus";
import { canShowScreeningScoreForViewer } from "../../utils/screeningScore";
import ReportReprocessingIndicator from "./ReportReprocessingIndicator";

type NavigationOrigin = {
  pathname?: unknown;
  search?: unknown;
  hash?: unknown;
};

type BackNavigationTarget =
  | { kind: 'delta'; value: number }
  | { kind: 'path'; value: string }
  | null;

const normalizeNavigationValue = (value: unknown): string => {
  if (typeof value !== 'string') {
    return '';
  }

  return value.trim();
};

export const resolveBackNavigationTarget = ({
  hasLiveLocationState,
  fallbackOrigin,
  currentPathname,
}: {
  hasLiveLocationState: boolean;
  fallbackOrigin?: NavigationOrigin | null;
  currentPathname?: string;
}): BackNavigationTarget => {
  if (hasLiveLocationState) {
    return { kind: 'delta', value: -1 };
  }

  const pathname = normalizeNavigationValue(fallbackOrigin?.pathname);
  if (!pathname) {
    const normalizedCurrentPath = normalizeNavigationValue(currentPathname);
    if (normalizedCurrentPath.startsWith("/landloard")) {
      return { kind: "path", value: "/landloard" };
    }
    return { kind: "path", value: "/ats" };
  }

  const search = normalizeNavigationValue(fallbackOrigin?.search);
  const hash = normalizeNavigationValue(fallbackOrigin?.hash);

  return { kind: 'path', value: `${pathname}${search}${hash}` };
};

const ApplicantDetailBox = (props) => {
  // return <JSONTree data={props} />;

  const navigate = useNavigate();
  // No changes need in this compoment as of now
  const trn_id = useSelector((state: RootState) => state.users.userTrnId);
  const { id, appType, applicationId } = useParams();
  // call get application inbox details data
  const { data, isLoading, error } = useGetOne("getapplicationinboxdetails", {
    id: props?.appDetails?.id,
  });
  const {
    data: applicantDatasub,
    isLoading: loading,
    refetch,
  } = useGetOne("getApplicantDetails", { id: trn_id }, { enabled: !!trn_id });



  const { data: userData } = useGetIdentity();
  const { permissions } = usePermissions();
  const applicationStatusBackgroundColor = (
    ApplicationStatus,
    ScreeningDetails
  ) => {
    if (
      ApplicationStatus === "Completed-Approved"
    ) {
      return "#E6FDF0";
    }

    else if (ApplicationStatus === "Completed-Unacceptable") {
      return "#F8ECE2";
    } else if (ApplicationStatus === "CompletedConditionallyApproved") {
      return "#FFF8E2";
    } else if (ApplicationStatus == "Review Pending") {
      return "#ecfbff";
    } else if (ApplicationStatus == "Application In Progress") {
      return "#DDF8FF";
    } else if (ApplicationStatus == "Submitted") {
      return "#B0EFFF";
    } else if (
      ScreeningDetails == "ConditionallyApproved" ||
      ScreeningDetails == "Conditionally Approved"
    ) {
      return "#FFF8E2";
    } else if (ScreeningDetails == "Unacceptable") {
      return "#F8ECE2";
    } else if (
      ScreeningDetails == "NoAssessment" ||
      ScreeningDetails == "No Assessment"
    ) {
      return "#fff";
    }
    else if (
      ScreeningDetails == "Approved"
    ) {
      return "#E6FDF0";
    }

    return "#E9E9E9";
  };
  const applicationStatusTextColor = (
    ApplicationStatus,
    ScreeningDetails
  ) => {
    if (
      ApplicationStatus === "Completed-Approved"
    ) {
      return "#46A96F";
    }
    else if (ApplicationStatus === "Completed-Unacceptable") {
      return "#FF4848";
    } else if (ApplicationStatus === "CompletedConditionallyApproved") {
      return "#F9BB04";
    } else if (ApplicationStatus == "Review Pending") {
      return "#2dc3e8";
    } else if (ApplicationStatus == "Application In Progress") {
      return "#1CA2C2";
    } else if (ApplicationStatus == "Submitted") {
      return "#127790";
    } else if (
      ScreeningDetails == "ConditionallyApproved" ||
      ScreeningDetails == "Conditionally Approved"
    ) {
      return "#F9BB04";
    } else if (ScreeningDetails == "Unacceptable") {
      return "#FF4848";
    } else if (
      ScreeningDetails == "NoAssessment" ||
      ScreeningDetails == "No Assessment"
    ) {
      return "#000000";
    } else if (
      ScreeningDetails == "Approved"
    ) {
      return "#46A96F";
    }

    return "#909090";
  };

  const appDetails = data?.data[0];
  const statusLabel = getAtsStatusDisplayLabel(appDetails?.ApplicationStatus);
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const encodedData: any = searchParams.get("data");
  let locationState: any = {};
  if (encodedData) {
    locationState = JSON.parse((encodedData));
  }
  const notify = useNotify();
  const [create] = useCreate();
  const dataProvider = useDataProvider();
  const logo = applicantDatasub?.office_logo || applicantDatasub?.property_logo ? applicantDatasub?.office_logo || applicantDatasub?.property_logo : applicantDatasub?.subscriber_logo;
  const [isLoadingScreeningReport, setIsLoadingReport] = useState(false);
  const onClickScreeningReport = async (event) => {
    const { data: applicantData } = await dataProvider.getList(
      "get_subscriber_inbox_details",
      {
        pagination: { page: 1, perPage: 10 },
        sort: { field: "id", order: "DESC" },
        filter: {
          ApplicationNumber: applicationId,
          subscriberid: locationState?.SubscriberID,
        },
      }
    );

    create(
      "getscreeningreport",
      {
        data: {
          applicantID: applicantData[0]?.id,
          subscriberId: locationState?.SubscriberID,
        },
      },
      {
        onSuccess: (data) => {
          notify(`Screening report opened successfully.`, {
            type: "success",
            anchorOrigin: { vertical: "top", horizontal: "right" },
          });
        },
        onError: (e: any) =>
          notify(`Operation fail:${e.message}`, {
            type: "error",
            anchorOrigin: { vertical: "top", horizontal: "right" },
          }),
      }
    );
  };
  return (
    <>
      <div className="row">
        {appType == "1" && (
          <div
            className=""
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "left",
              flexDirection: "row",
            }}
          >
            <img
              src={logo}
              alt="Logo"
              style={{
                maxWidth: "50px",
                height: "auto",
                marginRight: "5px",
                display: logo ? "initial" : "none", // Hide the entire image if the source is falsy
              }}
              onError={(e) => {
                const target = e.target as HTMLImageElement; // Cast to HTMLImageElement
                target.style.display = "none"; // Hide the broken image
              }}
            />

            {!loading && (
              <strong>
                {applicantDatasub?.subscriber_details?.CompanyName}
              </strong>
            )}
          </div>
        )}
        <div className="col-12-sm d-flex">
          <br />
          <div role="presentation">
            <Breadcrumbs aria-label="breadcrumb">
              <Typography sx={{ fontWeight: "bold" }}>
                <button
                  title="Go Back"
                  style={{ color: "#2cc0e4" }}
                  className="btn btn-link"
                  onClick={() => {
                    const backTarget = resolveBackNavigationTarget({
                      hasLiveLocationState: Boolean(location?.state),
                      fallbackOrigin: locationState?.from,
                      currentPathname: location?.pathname,
                    });
                    if (!backTarget) {
                      return;
                    }
                    if (backTarget.kind === 'delta') {
                      navigate(backTarget.value);
                      return;
                    }
                    navigate(backTarget.value);
                  }}
                >
                  {" "}
                  <ArrowBack />
                </button>
                <span>Applicant Details</span>
              </Typography>
            </Breadcrumbs>
          </div>
        </div>
        <div className="col-sm-12">
          <VerificationInfoMessage
            userRole={userData?.userrole}
            show={appType === "1"}
            className="mb-2"
          />
        </div>
        {isLoading ? (
          <div className="col-sm-12">
            <div className="details-card-row mr-b30">
              <div className="static-d-info d-flex justify-content-center align-items-center">
                <CircularProgress size="30px" />
                <h5>&nbsp; &nbsp; Loading...</h5>
              </div>
            </div>
          </div>
        ) : (
          <div className="col-sm-12">
            <div className="details-card-row applicant-summary-card mr-b30">
              <div className="static-d-info">
                <label>App ID</label>
                <h5 style={{ fontWeight: "bold" }}>
                  {appDetails?.id ? appDetails?.id : "NA"}
                </h5>
              </div>
              <div className="static-d-info">
                <label>App Date</label>

                <h5>
                  <DateComponent date={appDetails?.AppDate} />
                </h5>
              </div>
              <div className="static-d-info">
                <label>Agent</label>
                <h5
                  title={appDetails?.Agent}
                  style={{
                    maxWidth: "150px",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    // display: "inline-block",
                  }}
                >
                  {appDetails?.Agent ? appDetails?.Agent : "NA"}
                </h5>
              </div>
              <div className="static-d-info">
                <label>Property/Office</label>
                <h5>{appDetails?.Property ? appDetails?.Property : "NA"}</h5>
              </div>
              <div className="static-d-info">
                <label>
                  App Address
                  {appDetails?.Subscribertype == "Real Estate" &&
                    appDetails?.ApplicationStatus !== "Invited" && !(userData?.userrole == typesofUsers.landlordThirdPartyAgent) && (
                      <IconButton size="small">
                        <AddressRentEdit
                          record={appDetails}
                          desiredMoveInDate
                          fontSize={"8px"}
                        />
                      </IconButton>
                    )}
                </label>
                <h5
                  title={appDetails?.AppliedForAddress}
                  style={{
                    maxWidth: "150px",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    // display: "inline-block",
                  }}
                >
                  {appDetails?.AppliedForAddress
                    ? appDetails?.AppliedForAddress
                    : "NA"}
                </h5>
              </div>
              <div className="static-d-info">
                <label>
                  Rent
                  {appDetails?.Subscribertype == "Real Estate" &&
                    appDetails?.ApplicationStatus !== "Invited" && !(userData?.userrole == typesofUsers.landlordThirdPartyAgent) ? (
                    <IconButton size="small">
                      <AddressRentEdit
                        record={appDetails}
                        desiredMoveInDate
                        fontSize={"8px"}
                      />
                    </IconButton>
                  ) : (
                    <IconButton size="small">
                      <AddressRentEditForProperty
                        record={appDetails}
                      />
                    </IconButton>

                  )}
                </label>
                <h5>
                  <NumericFormat
                    thousandSeparator=","
                    displayType="text"
                    thousandsGroupStyle="thousand"
                    decimalScale={2}
                    prefix="$"
                    fixedDecimalScale
                    value={
                      appDetails?.AppliedForRent
                        ? appDetails?.AppliedForRent
                        : "NA"
                    }
                  />
                </h5>
              </div>
              <div className="static-d-info">
                <label>Desired City</label>
                <h5>
                  {" "}
                  {appDetails?.AppliedForAddress
                    ? appDetails?.AppliedForAddress?.split(",")[1]
                    : "NA"}
                </h5>
              </div>
              <div className="static-d-info">
                <label>
                  Desired Move In
                  {appDetails?.Subscribertype == "Real Estate" &&
                    appDetails?.ApplicationStatus !== "Invited" && !(userData?.userrole == typesofUsers.landlordThirdPartyAgent) && (
                      <IconButton size="small">
                        <AddressRentEdit
                          record={appDetails}
                          desiredMoveInDate
                          fontSize={"8px"}
                        />
                      </IconButton>
                    )}
                </label>
                <h5>
                  {appDetails?.DesiredDate
                    ? moment(appDetails?.DesiredDate).format("MM/DD/YYYY")
                    : "NA"}
                </h5>
              </div>
              <div className="static-d-info static-d-info--status">
                <Box
                  className="app-summary-status"
                  display={"flex"}
                  flexDirection={"column"}
                  alignItems={"center"}
                >
                  <MuiButton
                    variant="contained"
                    disableElevation={true}
                    style={{
                      // color: "#127790",
                      fontSize: "12px",
                      // height: "32px",
                      textTransform: "capitalize",
                      cursor: "text",
                      fontFamily: "OpenSans-SemiBold",
                      padding: "5px 10px",
                      background:
                        applicationStatusBackgroundColor(appDetails?.ApplicationStatus, appDetails?.Archived == true ? "Archived" : appDetails?.ScreeningDetails),


                      color:
                        applicationStatusTextColor(appDetails?.ApplicationStatus, appDetails?.Archived == true ? "Archived" : appDetails?.ScreeningDetails),
                    }}
                  >
                    {appDetails.Archived === true
                      ? `Archived - ${statusLabel}`
                      : statusLabel}

                  </MuiButton>
                </Box>
              </div>

              {canShowScreeningScoreForViewer(
                appDetails?.Score,
                appDetails?.ApplicationStatus,
                userData?.userrole, appDetails?.HasPreservedScreeningReport
              ) && (
                <div className="static-d-info static-d-info--score">
                  <Box
                    className="app-summary-score"
                    display={"flex"}
                    flexDirection={"column"}
                    alignItems={"center"}
                  >
                    <Avatar
                      sx={{
                        bgcolor:
                          appDetails?.ScreeningDetails ===
                            "ConditionallyApproved" ||
                            appDetails?.ScreeningDetails ===
                            "Conditionally Approved"
                            ? "#FFF8E2"
                            : appDetails?.ScreeningDetails === "Unacceptable"
                              ? "#F8ECE2"
                              : appDetails?.ScreeningDetails === "NoAssessment" ||
                                appDetails?.ScreeningDetails === "No Assessment"
                                ? "#fff"
                                : appDetails?.ScreeningDetails === ""
                                  ? "inherit"
                                  : "#E6FDF0",
                        border:
                          appDetails?.ScreeningDetails ===
                            "ConditionallyApproved" ||
                            appDetails?.ScreeningDetails ===
                            "Conditionally Approved"
                            ? " 1px solid #F9BB04"
                            : appDetails?.ScreeningDetails === "Unacceptable"
                              ? "1px solid #FF4848"
                              : appDetails?.ScreeningDetails === "NoAssessment" ||
                                appDetails?.ScreeningDetails === "No Assessment"
                                ? "1px solid #000000"
                                : appDetails?.ScreeningDetails === ""
                                  ? "inherit"
                                  : "1px solid #46A96F",
                        color:
                          appDetails?.ScreeningDetails ===
                            "ConditionallyApproved" ||
                            appDetails?.ScreeningDetails ===
                            "Conditionally Approved"
                            ? "#F9BB04"
                            : appDetails?.ScreeningDetails === "Unacceptable"
                              ? "#FF4848"
                              : appDetails?.ScreeningDetails === "NoAssessment" ||
                                appDetails?.ScreeningDetails === "No Assessment"
                                ? "#000000"
                                : appDetails?.ScreeningDetails === ""
                                  ? "inherit"
                                  : "#46A96F",
                      }}
                    >
                      {appDetails?.Score}
                    </Avatar>

                    <Box
                      className="app-summary-score-actions"
                      display={"flex"}
                      justifyContent={"center"}
                    >
                      {isSuperAdmin(checkModuleAccess(permissions, "Inbox", "Screening Report"), userData?.userrole) && <MuiButton
                        disabled={isLoadingScreeningReport}
                        size="small"
                        // label="View"
                        variant="text"
                        onClick={(event) =>
                          onClickScreeningReport(event)
                        }
                      >
                        View
                      </MuiButton>}
                      <ReportReprocessingIndicator active={appDetails?.HasPreservedScreeningReport} iconOnly />
                      {appDetails.SecondaryApp && !appDetails.EmailStatus && (
                        <IconButton sx={{ p: "4px" }} size="small">
                          <WarningPrelimNotice showWithScoreAsIcon={true} />
                        </IconButton>
                      )}
                    </Box>
                  </Box>
                </div>
              )}
              <div className="static-d-info static-d-info--ri">
                <Box
                  display={"flex"}
                  alignItems={"center"}
                  justifyContent={"start"}
                >
                  <label> RI%</label>
                  <BasicPopover />
                </Box>

                <h5>{appDetails?.RI ? appDetails?.RI : "NA"}</h5>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default ApplicantDetailBox;
